const { initClientSideStrategies} = require("@/simulation/automation/clientSideStrategies.js");
const {initServerSideStrategies,  getSTAMPriority} = require("@/simulation/automation/serverSideStrategies.js");
const { initClientSideMetrics } = require("@/simulation/metrics/clientSideMetrics.js");
const { Simulator } = require("@/simulation/simulator.js");
const { Visualiser } = require("@/visualisation/visualiser.js");
var d3 = require("d3");

class PipelineHandler {
  constructor(component) {
    this.component = component;
    this.state = this.component.$store.state;
    this.toast = this.component.$toast;

  }

  //When presseplay either start manual or automatic
  pressedPlay(singleStep) {
    //Already finished
    if (this.state.simulator.currState == "allProjectsFinished") {
      return this.showFinishedProjectsMessage();
    }
    if (this.state.simulator.currState == "simulationFinished") {
      return this.showFinishedSimMessage();
    }

    if (this.state.simulator.params.isManual) {
      this.startManualPlay(singleStep);
    }
    else {
      this.startAutomaticPlay(false, singleStep);
    }
  }

  showFinishedSimMessage() {
    this.toast.success("The simulation has finished", {
      position: "bottom-right",
      timeout: 5000,
    });
  }

  showFinishedProjectsMessage() {
    this.toast.success("All the projects were finished", {
      position: "bottom-right",
      timeout: 5000,
    });
  }

  startManualPlay(singleStep) {

    // 

    var continueLoop = this.handleStepSimulation("manual", {});

    //Something finished
    if (!continueLoop || singleStep) {
      this.state.manuallyPaused = true;
      this.state.visualiser.updateElements();
      return;
    }

    //Continue looping
    var self = this;
    setTimeout(function () {
      self.startManualPlay();
    }, this.state.visualiser.params.duration);
  }

  handleStepSimulation(mode, eventDict) {
    var visualiser = this.state.visualiser;
    var simulator = this.state.simulator;

    var continueSimulation = this.checkIfContinueSimulation();
    if (!continueSimulation) {
      return false;
    }

    //First handle possible events
    if (simulator.hoursPassed in eventDict) {
      simulator.handleAllNewEvents(eventDict[simulator.hoursPassed]);
    }

    //Simulate and move the items for one timestep
    var pause = false;
    if (this.component.$route.name == "Pipeline") {
      if (mode == "automatic") {
        pause = simulator.automateOneStep();
      } else if (mode == "manual") {
        pause = simulator.simulateOneStep();
      }
    }
    
    if (this.state.simulator.isSimulationFinished()) {
      this.storeResults();
      pause = true;
    }

    if (this.state.simulator.currState == "allProjectsFinished") {
      return this.showFinishedProjectsMessage();
    }
    if (this.state.simulator.currState == "simulationFinished") {
      return this.showFinishedSimMessage();
    }
    
    visualiser.updateElements();

    return !pause;
  }

  storeResults() {
    if (!this.storedResults) {
      this.state.networkHandler.storePerformanceResults();
      this.storedResults = true;
    }
  }

  checkIfContinueSimulation() {
    var visualiser = this.state.visualiser;
    var simulator = this.state.simulator;

    if (simulator.isSimulationFinished()) {
      return false;
    }

    //User pressed pause, make sure that the visuals are correct
    if (this.state.manuallyPaused) {
      visualiser.updateElements(true);
      return false;
    }

    //Don't simulate if not all possible resources are assigned
    if (simulator.resourcePool.notAllResourcesAssigned() && visualiser.params.forceAllAssignments && simulator.params.isManual) {
      this.toast.warning("Not all resources are assigned", {
        position: "bottom-right",
        timeout: 7500,
      });
      visualiser.updateElements(true);
      return false;
    }


    return true;
  }

  askForAutomationMethod(untilEnd, singleStep) {
    var options = this.state.SimulationOptions;
    var visualiser = this.state.visualiser;
    var simulator = this.state.simulator;
    var self = this;
    this.component.$swal
      .fire({
        title: "Automation",
        text: "Select a simulation method",
        input: "select",
        inputOptions: options,
        showCancelButton: true,
        animation: "slide-from-top",
      })
      .then(function (inputValue) {
        if (inputValue && !inputValue.isDismissed) {
          simulator.automationMethod = inputValue.value;
          if (visualiser.params.simulateTillEnd || untilEnd) {
            self.startAutomateUntilEnd(inputValue.value);
          } else {
            self.state.manuallyPaused = false;
            self.startAutomation("automatic", [], singleStep);
          }
        } else {
          self.state.manuallyPaused = true;
        }
      });
  }


  startAutomaticPlay(untilEnd, singleStep) {

    if (this.state.simulator.params.isManual && untilEnd) {
      console.log("Cant simulate the manual version");
      return;
    }

    //If a simulation method has been chosen, continue automation
    if(this.state.simulator.params.allowPortfolioPlanning){
      this.state.simulator.automationMethod = "EpicFlow";
    }

    if (this.state.simulator.automationMethod == null) {
      this.askForAutomationMethod(untilEnd, singleStep);
      return;
    }

    if (untilEnd)
      this.startAutomateUntilEnd(this.state.simulator.automationMethod);
    else
    this.state.manuallyPaused = false;
      this.startAutomation("automatic", [], singleStep);
  }

  //Fully simulate and then render, nothing inbetween
  startAutomateUntilEnd(automationMethod, events) {
    this.state.simulator.automateUntilEnd(automationMethod, events)
    this.state.manuallyPaused = true;
    this.state.visualiser.updateElements();
  }

  startAutomation(mode, events, singleStep) {
    const eventDict = this.state.simulator.eventsListToDict(events);
    var continueLoop = this.handleStepSimulation(mode, eventDict);
    if (continueLoop && !singleStep) {
      setTimeout(
        this.startAutomation.bind(this),
        this.state.visualiser.params.duration,
        mode,
        events
      );
    }
    else{
      this.state.manuallyPaused = true;
      this.state.visualiser.updateElements();
    }
  }


  init(selectedSim) {
    var parentDiv = document.querySelector(".gantt-chart-container");
    this.storedResults = false;

    var prevTransform = null;
    if (this.state.visualiser != null) {
      prevTransform = this.state.visualiser.transform;
    }

    if (!this.state.mounted) {
      this.createSimulator(selectedSim);
      this.createVisualiser(parentDiv, prevTransform);
    } else {
      this.state.visualiser.reloadVisualiser(
        this.state.ResourceComponents,
        this.state.topBar,
        parentDiv,
        prevTransform
      );
    }

    this.component.setupRedraw();
    this.component.setupGraph();
    this.state.mounted = true;
  }

  resetEnvironment() {
    this.state.visualiser.unloadVisualiser();
    this.state.manuallyPaused = true;
    this.state.mounted = false;
    this.component.mountedGraph = false;
  }

  createSimulator(selectedSim) {
    initClientSideStrategies();
    initServerSideStrategies();
    var projectData = this.state.AllProjects;
    this.state.simulator = new Simulator(selectedSim, projectData);
    initClientSideMetrics(this.state.simulator.performanceTracker); 
  }
  createVisualiser(parentDiv, prevTransform) {
    this.state.visualiser = new Visualiser(
      this.state.simulator,
      parentDiv,
      this.state.mounted,
      this.state.ResourceComponents,
      prevTransform,
      this.state.durationValue,
      this.state.topBar,
      this.state
    );
  }
}

module.exports = { PipelineHandler };



